module.exports = __webpack_public_path__ + "static/media/22.3085de7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Carousel/CarouselMedia/22.jpg
// module id = 183
// module chunks = 0